<template>
    <div class="agent-page">
        <div style="display: flex; align-items: center; justify-content: space-between;">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">{{ !!winBulletinCode ? "中标结果公告详情" : "新增中标结果公告" }}</h2>
            </div>
            <div style="display: flex; align-items: center; gap: 10px;">
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack" size="small">返回</el-button>
            </div>
        </div>
        <!-- 内容区域 -->
        <div class="content-wrap">
            <el-form :model="form" :rules="rules" ref="form" label-width="250px" class="win-bulletin-form">
                <!-- 基本信息 -->
                <div class="form-section">
                    <el-form-item label="选择标段:" prop="bidSectionCode" required>
                        <el-select v-model="form.bidSectionCode" placeholder="请选择标段" style="width: 30%"
                            @change="handleBidSectionChange" :disabled="!!winBulletinCode">
                            <el-option v-for="item in bidSectionList" :key="item.bidSectionCode"
                                :label="item.bidSectionName" :value="item.bidSectionCode">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="中标结果公告标题:" prop="winBulletinName" required>
                        <el-input v-model="form.winBulletinName" placeholder="请输入中标结果公告标题" :disabled="!!winBulletinCode"
                            style="width: 30%"></el-input>
                    </el-form-item>

                    <el-form-item label="公示类型:" prop="typeCode" required>
                        <el-select v-model="form.typeCode" placeholder="请选择公示类型" style="width: 30%"
                            :disabled="!!winBulletinCode">
                            <el-option label="正常公示" :value="1"></el-option>
                            <el-option label="更正" :value="2"></el-option>
                            <el-option label="其他" :value="9"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="发布时间:" prop="publicTime" required>
                        <app-date-picker v-model="form.publicTime" type="datetime" placeholder="选择发布时间"
                            style="width: 30%" value-format="yyyy-MM-dd HH:mm:ss" :disabled="!!winBulletinCode">
                        </app-date-picker>
                    </el-form-item>
                </div>

                <!-- 代理项目经理信息 -->
                <div class="form-row">
                    <div class="form-column">
                        <el-form-item label="代理项目经理:" prop="agencyManager">
                            <el-input v-model="form.agencyManager" placeholder="请输入代理项目经理"
                                :disabled="!!winBulletinCode"></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-column">
                        <el-form-item label="代理项目经理身份证:" prop="agencyManagerId">
                            <el-input v-model="form.agencyManagerId" placeholder="请输入代理项目经理身份证"
                                :disabled="!!winBulletinCode"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <!-- 中标结果公告内容 -->
                <el-form-item label="中标结果公告内容:" prop="winBulletinContent" required>
                    <RichTextEditor v-model="form.winBulletinContent" :height="300" placeholder="请输入中标结果公告内容..."
                        toolbar-type="default" :disabled="!!winBulletinCode" />
                </el-form-item>

                <!-- 与中标候选人不一致原因 -->
                <el-form-item label="与中标候选人第一名不一致原因:" prop="notAccordanceReason">
                    <el-input v-model="form.notAccordanceReason" type="textarea" :rows="4"
                        placeholder="请输入与中标候选人第一名不一致原因" resize="both" :disabled="!!winBulletinCode">
                    </el-input>
                </el-form-item>

                <!-- 异议渠道或方式 -->
                <el-form-item label="异议渠道或方式:" prop="complaints">
                    <el-input v-model="form.complaints" type="textarea" :rows="4" placeholder="请输入异议渠道或方式" resize="both"
                        :disabled="!!winBulletinCode">
                    </el-input>
                </el-form-item>

                <!-- 其他说明 -->
                <el-form-item label="其他说明:" prop="otherContent">
                    <el-input v-model="form.otherContent" type="textarea" :rows="4" placeholder="请输入其他说明" resize="both"
                        :disabled="!!winBulletinCode">
                    </el-input>
                </el-form-item>

                <!-- 中标人信息 -->
                <div class="form-section">
                    <h3 class="section-title">中标人信息</h3>

                    <el-form-item label="选择中标人:" prop="selectedBidder" required v-if="winBulletinCode == ''">
                        <el-select v-model="form.selectedBidder" placeholder="请选择中标人" style="width: 30%"
                            @change="handleBidderChange" :disabled="!form.bidSectionCode || !!winBulletinCode">
                            <el-option v-for="item in biddersList" :key="item.bidderCode"
                                :label="`${item.bidderName} (排名: ${item.orders})`" :value="item.bidderCode">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <div v-if="currentBidder" class="bidder-detail">
                        <div class="form-row">
                            <div class="form-column">
                                <el-form-item label="中标人:" prop="winBidderList.0.winBidderName">
                                    <el-input v-model="currentBidder.winBidderName" placeholder="请输入中标人"
                                        :disabled="!!winBulletinCode"></el-input>
                                </el-form-item>

                                <el-form-item label="中标人单位编号:" prop="winBidderList.0.winBidderUserId">
                                    <el-input v-model="currentBidder.winBidderUserId" placeholder="请输入中标人单位编号"
                                        :disabled="!!winBulletinCode"></el-input>
                                </el-form-item>

                                <el-form-item label="是否联合体:" prop="winBidderList.0.winBidderIsUnion">
                                    <el-select v-model="currentBidder.winBidderIsUnion" placeholder="请选择"
                                        style="width: 100%" :disabled="!!winBulletinCode">
                                        <el-option label="否" :value="0"></el-option>
                                        <el-option label="是" :value="1"></el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="中标人项目经理(负责人):" prop="winBidderList.0.winBidderPm">
                                    <el-input v-model="currentBidder.winBidderPm" placeholder="请输入中标人项目经理"
                                        :disabled="!!winBulletinCode"></el-input>
                                </el-form-item>

                                <el-form-item label="项目经理证件类型:" prop="winBidderList.0.winBidderIdType">
                                    <el-select v-model="currentBidder.winBidderIdType" placeholder="请选择证件类型"
                                        style="width: 100%" :disabled="!!winBulletinCode">
                                        <el-option label="身份证" :value="1"></el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="项目经理证件编号:" prop="winBidderList.0.winBidderId">
                                    <el-input v-model="currentBidder.winBidderId" placeholder="请输入项目经理证件编号"
                                        :disabled="!!winBulletinCode"></el-input>
                                </el-form-item>

                                <el-form-item label="项目经理电话:" prop="winBidderList.0.winBidderPmTel">
                                    <el-input v-model="currentBidder.winBidderPmTel" placeholder="请输入项目经理电话"
                                        :disabled="!!winBulletinCode"></el-input>
                                </el-form-item>
                            </div>

                            <div class="form-column">
                                <el-form-item label="中标人所在地区:" prop="winBidderList.0.winBidderRegion">
                                    <el-cascader v-model="currentBidder.winBidderRegion" :props="regionProps"
                                        placeholder="请选择中标人所在地区" style="width: 100%" @change="handleRegionChange"
                                        clearable ref="cascader" :disabled="!!winBulletinCode">
                                    </el-cascader>
                                </el-form-item>

                                <el-form-item label="价款形式:" prop="winBidderList.0.priceFormCode">
                                    <el-select v-model="currentBidder.priceFormCode" placeholder="请选择价款形式"
                                        style="width: 100%" :disabled="!!winBulletinCode">
                                        <el-option label="总价" :value="1"></el-option>
                                        <el-option label="单价" :value="2"></el-option>
                                        <el-option label="费率" :value="3"></el-option>
                                        <el-option label="其他" :value="9"></el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="单位:" prop="winBidderList.0.priceUnit">
                                    <el-select v-model="currentBidder.priceUnit" placeholder="请选择单位" style="width: 100%"
                                        :disabled="!!winBulletinCode">
                                        <el-option label="元" :value="0"></el-option>
                                        <el-option label="万元" :value="1"></el-option>
                                        <el-option label="%" :value="2"></el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="中标金额:" prop="winBidderList.0.bidAmount">
                                    <el-input-number v-model="currentBidder.bidAmount" :min="0" :precision="2"
                                        placeholder="请输入中标金额" style="width: 100%"
                                        :disabled="!!winBulletinCode"></el-input-number>
                                </el-form-item>

                                <el-form-item label="费率或其它类型结果:" prop="winBidderList.0.otherBidPrice">
                                    <el-input v-model="currentBidder.otherBidPrice" placeholder="请输入费率或其它类型结果"
                                        :disabled="!!winBulletinCode"></el-input>
                                </el-form-item>

                                <el-form-item label="投标人资格条件:" prop="winBidderList.0.bidderQualification">
                                    <el-input v-model="currentBidder.bidderQualification" type="textarea" :rows="3"
                                        placeholder="请输入投标人资格条件" :disabled="!!winBulletinCode"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 附件上传 -->
                <el-form-item label="附件:" prop="fileList">
                    <div class="upload-container" v-if="!winBulletinCode">
                        <el-button type="primary" @click="handleSelectFile">选择文件</el-button>
                        <input type="file" ref="fileInput" style="display: none" multiple @change="handleFileChange" />
                        <span class="upload-tip">支持上传多个文件</span>
                    </div>
                    <div v-if="fileList.length > 0" class="file-list">
                        <div v-for="(file, index) in fileList" :key="index" class="file-item">
                            <span class="file-name">{{ file.name }}</span>
                            <el-progress v-if="file.uploading" :percentage="file.progress"></el-progress>
                            <span v-if="file.uploaded" class="file-status success">已上传</span>
                            <el-button type="text" @click="removeFile(index)" v-if="!winBulletinCode">删除</el-button>
                        </div>
                    </div>
                </el-form-item>

                <!-- 底部按钮 -->
                <div class="form-actions" v-if="!winBulletinCode">
                    <el-button @click="handleSave(0)">暂存</el-button>
                    <el-button type="primary" @click="handleSave(1)">提交</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import RichTextEditor from '@/components/common/RichTextEditor.vue'
import { loadProjectDetail } from '@/utils/projectInfo.js'
import { winBulletinAdd, winBulletinBidSectionList, winBulletinBidders, winBulletinDetail } from '@/api/winBulletin/api'
import RegionUtils from '@/utils/regionUtils'
import { doFileUpload } from '@/utils/fileUploadHelper'
import { getFileList } from '@/api/base/api'
export default {
    name: 'AddBidNotice',
    components: {
        RichTextEditor
    },
    data() {
        return {
            projectCode: this.$route.query.projectCode,
            winBulletinCode: "",
            projectTitle: '',
            bidSectionList: [], // 标段列表
            biddersList: [], // 中标人列表
            regionProps: RegionUtils.getCascaderProps(),
            fileList: [], // 文件列表
            currentBidder: null, // 当前选中的中标人
            form: {
                projectCode: this.$route.query.projectCode,
                bidSectionCode: '',
                bidSectionName: '',
                winBulletinCode: '',
                winBulletinName: '',
                winBulletinContent: '',
                typeCode: 1,
                publicTime: '',
                agencyManager: '',
                agencyManagerId: '',
                notAccordanceReason: '',
                complaints: '',
                otherContent: '',
                fileGuid: '',
                status: 0,
                selectedBidder: '', // 选中的中标人编号
                winBidderList: []
            },
            rules: {
                bidSectionCode: [
                    { required: true, message: '请选择标段', trigger: 'change' }
                ],
                winBulletinName: [
                    { required: true, message: '请输入中标结果公告标题', trigger: 'blur' }
                ],
                winBulletinContent: [
                    { required: true, message: '请输入中标结果公告内容', trigger: 'blur' }
                ],
                typeCode: [
                    { required: true, message: '请选择公示类型', trigger: 'change' }
                ],
                publicTime: [
                    { required: true, message: '请选择发布时间', trigger: 'change' }
                ],
                selectedBidder: [
                    { required: true, message: '请选择中标人', trigger: 'change' }
                ]
            }
        }
    },
    mounted() {
        this.getProjectInfo()
        this.getBidSectionList()
        this.initFileGuid()
        if (this.$route.query.winBulletinCode) {
            this.winBulletinCode = this.$route.query.winBulletinCode
            this.winBulletinDetail()
        }
    },
    methods: {
        // 初始化文件关联标识
        initFileGuid() {
            this.form.fileGuid = new Date().getTime() + Math.random().toString().substr(2, 5)
        },

        // 获取项目信息
        async getProjectInfo() {
            try {
                this.projectTitle = await loadProjectDetail(this.projectCode)
            } catch (error) {
                console.error('获取项目信息失败:', error)
            }
        },
        //  获取中标结果公告详情
        winBulletinDetail() {
            winBulletinDetail({ winBulletinCode: this.$route.query.winBulletinCode }).then(res => {
                if (res.code === 200) {
                    console.log(JSON.stringify(res.data));
                    const detailData = res.data;
                    // 赋值
                    this.form.projectCode = detailData.projectCode;
                    this.form.bidSectionCode = detailData.bidSectionCode;
                    this.form.bidSectionName = detailData.bidSectionName;
                    this.form.winBulletinCode = detailData.winBulletinCode;
                    this.form.winBulletinName = detailData.winBulletinName;
                    this.form.winBulletinContent = detailData.winBulletinContent;
                    this.form.typeCode = detailData.typeCode;
                    this.form.publicTime = detailData.publicTime;
                    this.form.agencyManager = detailData.agencyManager;
                    this.form.agencyManagerId = detailData.agencyManagerId;
                    this.form.notAccordanceReason = detailData.notAccordanceReason;
                    this.form.complaints = detailData.complaints;
                    this.form.otherContent = detailData.otherContent;
                    this.form.fileGuid = detailData.fileGuid;
                    this.form.status = detailData.status;

                    // 处理中标人信息
                    if (detailData.bidders && detailData.bidders.length > 0) {
                        const bidderData = detailData.bidders[0];

                        // 构建地区数组
                        const regionArray = [];
                        if (bidderData.winBidderRegionProvinceCode) {
                            regionArray.push(bidderData.winBidderRegionProvinceCode);
                        }
                        if (bidderData.winBidderRegionCityCode) {
                            regionArray.push(bidderData.winBidderRegionCityCode);
                        }
                        if (bidderData.winBidderRegionCode) {
                            regionArray.push(bidderData.winBidderRegionCode);
                        }

                        // 设置当前中标人信息
                        this.currentBidder = {
                            winBidderGuid: bidderData.winBidderGuid,
                            winBidderName: bidderData.winBidderName,
                            winBidderUserId: bidderData.winBidderUserId,
                            winBidderIsUnion: bidderData.winBidderIsUnion,
                            winBidderPm: bidderData.winBidderPm,
                            winBidderIdType: bidderData.winBidderIdType,
                            winBidderId: bidderData.winBidderId,
                            winBidderPmTel: bidderData.winBidderPmTel,
                            winBidderRegion: regionArray,
                            winBidderRegionProvinceCode: bidderData.winBidderRegionProvinceCode,
                            winBidderRegionProvinceName: bidderData.winBidderRegionProvinceName,
                            winBidderRegionCityCode: bidderData.winBidderRegionCityCode,
                            winBidderRegionCityName: bidderData.winBidderRegionCityName,
                            winBidderRegionCode: bidderData.winBidderRegionCode,
                            winBidderRegionName: bidderData.winBidderRegionName,
                            priceFormCode: bidderData.priceFormCode,
                            priceUnit: bidderData.priceUnit,
                            bidAmount: bidderData.bidAmount,
                            otherBidPrice: bidderData.otherBidPrice,
                            bidderQualification: bidderData.bidderQualification,
                            winBulletinCode: bidderData.winBulletinCode
                        };

                        // 更新 winBidderList
                        this.form.winBidderList = [this.currentBidder];
                    }

                    // 获取附件列表
                    if (detailData.fileGuid != '' && detailData.fileGuid != null && detailData.fileGuid != 'undefined') {
                        this.getFileList(detailData.fileGuid);
                    }
                }
            })
        },
        //  获取附件列表
        getFileList(fileGuid) {
            getFileList(fileGuid).then(res => {
                if (res.code === 200 && res.data) {
                    this.fileList = (res.data || []).map(file => ({
                        name: file.fileName,
                        size: file.fileSize,
                        uploading: false,
                        uploaded: true,
                        progress: 100,
                        fileGuid: fileGuid,
                        uploadFileId: file.fileId,
                        filePath: file.fileUrl,
                        fileExtension: file.fileExtension
                    }));
                } else {
                    this.fileList = []
                }
            }).catch(error => {
                console.error('获取附件列表失败:', error)
                this.fileList = []
            })
        },
        // 获取标段列表
        async getBidSectionList() {
            try {
                const response = await winBulletinBidSectionList({ projectCode: this.projectCode })
                if (response && response.data) {
                    this.bidSectionList = response.data
                }
            } catch (error) {
                console.error('获取标段列表失败:', error)
                this.$message.error('获取标段列表失败')
            }
        },

        // 标段选择变化
        async handleBidSectionChange(bidSectionCode) {
            const selectedSection = this.bidSectionList.find(item => item.bidSectionCode === bidSectionCode)
            if (selectedSection) {
                this.form.bidSectionName = selectedSection.bidSectionName
            }

            // 清空之前选择的中标人
            this.form.selectedBidder = ''
            this.currentBidder = null
            this.biddersList = []

            if (!bidSectionCode) {
                return
            }

            // 获取中标人列表
            try {
                const response = await winBulletinBidders({
                    bidSectionCode: bidSectionCode,
                    stage: 0
                })
                if (response && response.data) {
                    this.biddersList = response.data
                }
            } catch (error) {
                console.error('获取中标人列表失败:', error)
                this.$message.error('获取中标人列表失败')
            }
        },

        // 中标人选择变化
        handleBidderChange(bidderCode) {
            const selectedBidder = this.biddersList.find(item => item.bidderCode === bidderCode)
            if (selectedBidder) {
                // 初始化中标人信息
                this.currentBidder = {
                    winBidderGuid: '',
                    winBidderName: selectedBidder.bidderName,
                    winBidderUserId: selectedBidder.bidderCode || '',
                    winBidderIsUnion: 0,
                    winBidderPm: '',
                    winBidderIdType: 1,
                    winBidderId: '',
                    winBidderPmTel: '',
                    winBidderRegion: [],
                    winBidderRegionProvinceCode: '',
                    winBidderRegionProvinceName: '',
                    winBidderRegionCityCode: '',
                    winBidderRegionCityName: '',
                    winBidderRegionCode: '',
                    winBidderRegionName: '',
                    priceFormCode: 1,
                    priceUnit: 0,
                    bidAmount: 0,
                    otherBidPrice: '',
                    bidderQualification: '',
                    winBulletinCode: ''
                }
                // 更新 winBidderList
                this.form.winBidderList = [this.currentBidder]
            }
        },

        // 地区选择变化
        async handleRegionChange(value) {
            if (!this.currentBidder) return
            const cascaderRef = this.$refs.cascader
            await RegionUtils.handleRegionChange(
                value,
                cascaderRef,
                this.currentBidder,
                {
                    provinceField: 'winBidderRegionProvinceName',
                    provinceCodeField: 'winBidderRegionProvinceCode',
                    cityField: 'winBidderRegionCityName',
                    cityCodeField: 'winBidderRegionCityCode',
                    countyField: 'winBidderRegionName',
                    countyCodeField: 'winBidderRegionCode',
                    regionField: 'winBidderRegion'
                },
                this
            )
        },

        // 选择文件
        handleSelectFile() {
            this.$refs.fileInput.click()
        },

        // 文件选择变化
        async handleFileChange(event) {
            const files = Array.from(event.target.files)
            if (files.length === 0) return

            for (const file of files) {
                const fileItem = {
                    name: file.name,
                    size: file.size,
                    uploading: true,
                    uploaded: false,
                    progress: 0,
                    fileGuid: '',
                    uploadFileId: '',
                    filePath: ''
                }
                this.fileList.push(fileItem)

                try {
                    const result = await doFileUpload(file, {
                        fileBindId: this.form.fileGuid,
                        onProgress: (percentage) => {
                            fileItem.progress = percentage
                        },
                        onSuccess: (res) => {
                            fileItem.uploading = false
                            fileItem.uploaded = true
                            fileItem.fileGuid = res.fileGuid
                            fileItem.uploadFileId = res.uploadFileId
                            fileItem.filePath = res.filePath
                        },
                        onError: (error) => {
                            fileItem.uploading = false
                            this.$message.error(`文件 ${file.name} 上传失败: ${error.message}`)
                        }
                    })
                } catch (error) {
                    fileItem.uploading = false
                    this.$message.error(`文件 ${file.name} 上传失败`)
                }
            }

            // 清空input
            event.target.value = ''
        },

        // 删除文件
        removeFile(index) {
            this.$confirm('确定要删除该文件吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.fileList.splice(index, 1)
                this.$message.success('删除成功')
            }).catch(() => { })
        },

        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },

        // 保存表单
        async handleSave(status) {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    try {
                        const submitData = {
                            ...this.form,
                            status: status
                        }
                        const response = await winBulletinAdd(submitData)
                        if (response.code === 0 || response.code === 200) {
                            const statusText = status === 0 ? '暂存' : status === 1 ? '提交' : '发布'
                            this.$message.success(`${statusText}成功！`)
                            setTimeout(() => {
                                this.handleBack()
                            }, 1500)
                        } else {
                            this.$message.error(response.message || '操作失败')
                        }
                    } catch (error) {
                        console.error('保存失败:', error)
                        this.$message.error('操作失败，请稍后重试')
                    }
                } else {
                    this.$message.error('请完善必填信息')
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/agent-common.css';

/* 内容区域样式 */
.content-wrap {
    width: 100%;
    background-color: #fff;
    padding: 30px;
    border-radius: 8px;
    margin-top: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    max-height: calc(100vh - 180px);
    overflow-y: auto;
}

/* 表单样式 */
.win-bulletin-form {
    text-align: start;

    .form-section {
        margin-bottom: 20px;
    }

    .form-row {
        display: flex;
        gap: 40px;
    }

    .form-column {
        flex: 1;
    }
}

/* 区块标题 */
.section-title {
    margin: 20px 0 15px 0;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    padding-left: 10px;
}

/* 中标人详情 */
.bidder-detail {
    margin-top: 20px;
    padding: 20px;
    //background-color: #f5f7fa;
    border-radius: 8px;
}

/* 文件上传样式 */
.upload-container {
    display: flex;
    align-items: center;
    gap: 10px;

    .upload-tip {
        color: #909399;
        font-size: 12px;
    }
}

.file-list {
    margin-top: 15px;

    .file-item {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px;
        background-color: #f5f7fa;
        border-radius: 4px;
        margin-bottom: 10px;

        .file-name {
            flex: 1;
            font-size: 14px;
            color: #606266;
        }

        .file-status {
            font-size: 12px;

            &.success {
                color: #67c23a;
            }
        }

        .el-progress {
            flex: 1;
        }
    }
}

/* 底部按钮样式 */
.form-actions {
    text-align: center;
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid #e4e7ed;

    .el-button {
        margin: 0 15px;
        padding: 12px 30px;
        font-size: 14px;
        border-radius: 4px;
        min-width: 100px;
    }
}

/* 表单验证错误样式 */
.el-form-item.is-error {

    .el-input__inner,
    .el-textarea__inner {
        border-color: #f56c6c;
    }
}
</style>
